import React, { useContext, useCallback } from 'react';
import './RoomDetail.css';
import PaxDispatch from '../../PaxDispatch';
import { UPDATE_ROOM, CHILD_AGE_PLACEHOLDER } from '../../../Constant/constants';
import AddChildrenAge from './AddChildrenAge';

const ADULTS = [1, 2, 3];
const CHILDREN = [0, 1, 2, 3];

const RoomDetail = ({ adults, children, roomIndex, paxConfig, childBedRequired }) => {
  const adultCount = adults || 0;
  const childCount = (children && children.length) || 0;
  const dispatch = useContext(PaxDispatch);
  const handleChildCountChange = count => {
    let updatedChildren = children || [];
    if (count < childCount) {
      updatedChildren = updatedChildren.slice(0, count);
    } else {
      updatedChildren = updatedChildren.concat(
        Array(count - childCount).fill(CHILD_AGE_PLACEHOLDER)
      );
    }
    dispatch({
      type: UPDATE_ROOM,
      index: roomIndex,
      room: {
        adults,
        children: updatedChildren,
        childBedRequired,
      },
    });
  };
  const handleChildChangeCallback = useCallback(
    (updatedChildren, childBedRequired) => {
      dispatch({
        type: UPDATE_ROOM,
        index: roomIndex,
        room: { adults, children: updatedChildren, childBedRequired },
      });
    },
    [adults, children, roomIndex]
  );
  const handleBedChangeCallback = useCallback(
    updatedBedRequired => {
      dispatch({
        type: UPDATE_ROOM,
        index: roomIndex,
        room: { adults, children, childBedRequired: updatedBedRequired },
      });
    },
    [adults, children, roomIndex, childBedRequired]
  );
  return (
    <div>
      <p className="room-detail_title">ADULTS (12y +)</p>
      <ul className="room-detail_age guestCounter font12 darkText">
        {ADULTS.map((count, index) => (
          <li
            className={`${adultCount === count ? 'selected' : ''}`}
            key={index}
            onClick={() =>
              dispatch({
                type: UPDATE_ROOM,
                index: roomIndex,
                room: { adults: count, children, childBedRequired },
              })
            }
          >
            {count}
          </li>
        ))}
      </ul>
      <p className="room-detail_title">CHILDREN (1y - 12y )</p>
      <ul className="room-detail_age guestCounter font12 darkText">
        {CHILDREN.map((count, index) => (
          <li
            className={`${childCount === count ? 'selected' : ''}`}
            id={`child-${count}`}
            key={index}
            onClick={() => handleChildCountChange(count)}
          >
            {count}
          </li>
        ))}
      </ul>
      {!!childCount && (
        <AddChildrenAge
          ages={children}
          handleChange={handleChildChangeCallback}
          handleBedRequiredChange={handleBedChangeCallback}
          paxConfig={paxConfig}
          bedRequired={childBedRequired}
        />
      )}
    </div>
  );
};

export default RoomDetail;
